import React from 'react';

import InvoicePageChip from '../../Components/InvoicePageChip/InvoicePageChip';

export const ChipSection = ({
  invoiceNumber,
  investigatorName,
  studyName,
  pcnName,
  siteName,
  siteNumber,
  invoiceDate
}) => {
  return (
    <div className="chip-section">
      <InvoicePageChip label="Date" value={invoiceDate} emptyValue="—" />
      <InvoicePageChip label="Invoice number" value={invoiceNumber} />
      <InvoicePageChip label="Investigator" value={investigatorName} emptyValue="—" />
      <InvoicePageChip label="Study" value={studyName} emptyValue="—" />
      <InvoicePageChip label="PCN" value={pcnName} emptyValue="—" />
      <InvoicePageChip label="Site Name" value={siteName} emptyValue="—" />
      <InvoicePageChip label="Site Number" value={siteNumber} emptyValue="—" />
    </div>
  );
};
